import React from 'react';
import PropTypes from 'prop-types';
// Permissions
import permissions from 'constants/Permissions';
import OnlyWith from 'components/permissions/OnlyWith';
// Code components
import Divider from 'components/core/Divider';
// Models
import mInstallation from 'models/installation';
// HOCs
import wrapListFilters from 'hocs/WrapListFilters';
// Custom
import { listFeatureSearchFieldShape, listFilterShape } from 'constants/PropTypesShapes';
import { yesNoAsList, toBooleanOrNull, toIntegerOrNull } from 'utils/Tools';
// Components
import FiltersTemplate from 'components/templates/FiltersTemplate';
import BaseListFilter from 'components/filters/BaseListFilter';
import TextFieldFilter from 'components/filters/TextFieldFilter';
import ItemsSelectFieldFilter from 'components/filters/ItemsSelectFieldFilter';
import DeviceAutoCompleteFilter from 'devices/assets/main/DeviceAutoCompleteFilter';
import CountryFilter from 'components/filters/CountryFilter';
import PeriodFilter from 'components/filters/PeriodFilter';
import CompanySelectFieldFilter from 'companies/assets/main/CompanySelectFieldFilter';

const InstallationFilters = ({
  asyncOperationsPeriodValue, onAsyncOperationsPeriodChange, disabled, advanced, nbFiltersApplied, searchFields, field, filters,
  isFieldDisplayable, onFieldChange, onFilterFieldChange, onReinit, onSwitch,
}) => {
  const {
    name, address, device, timeout, country, companyId,
  } = filters;

  return (
    <FiltersTemplate
      disabled={disabled}
      advanced={advanced}
      nbFiltersApplied={nbFiltersApplied}
      onReinit={onReinit}
      onSwitch={onSwitch}
    >
      <div className="row m-0">
        {!advanced && (
          <div className="col-12 col-md-4 col-xl-3">
            <BaseListFilter field={field} searchFields={searchFields} onChange={onFieldChange} />
          </div>
        )}
        {isFieldDisplayable('name') && (
          <div className="col-12 col-md-4 col-xl-3">
            <TextFieldFilter
              label="field.name"
              value={name.value}
              onChange={(value) => onFilterFieldChange('name', value)}
            />
          </div>
        )}
        {isFieldDisplayable('address') && (
          <div className="col-12 col-md-4 col-xl-3">
            <TextFieldFilter
              label="field.addressZipcodeCity"
              value={address.value}
              onChange={(value) => onFilterFieldChange('address', value)}
            />
          </div>
        )}
        {isFieldDisplayable('device') && (
          <div className="col-12 col-md-4 col-xl-3">
            <DeviceAutoCompleteFilter
              device={device.value}
              onSelect={(value) => onFilterFieldChange('device', value)}
            />
          </div>
        )}
        {isFieldDisplayable('timeout') && (
          <div className="col-12 col-md-4 col-xl-3">
            <ItemsSelectFieldFilter
              labelId="field.withDeviceTimeout"
              value={toBooleanOrNull(timeout.value)}
              items={yesNoAsList}
              onChange={(value) => onFilterFieldChange('timeout', value)}
            />
          </div>
        )}
        {isFieldDisplayable('companyId') && (
          <div className="col-12 col-md-4 col-xl-3">
            <CompanySelectFieldFilter
              companyId={toIntegerOrNull(companyId.value)}
              onChange={(value) => onFilterFieldChange('companyId', value)}
            />
          </div>
        )}
        <div className="col-12 px-0 pt-3">
          <div className="px-3">
            <Divider />
          </div>
          <div className="d-flex align-items-center px-3 py-2">
            <CountryFilter value={country.value} onChange={(value) => onFilterFieldChange('country', value)} />
          </div>
        </div>
        <OnlyWith permissions={{ needed: permissions.pAdmin }}>
          <div className="col-12 px-0">
            <div className="box-dark d-flex align-items-center px-3 py-2">
              <PeriodFilter
                labelId="info.asyncOperationsPeriodFilter"
                value={asyncOperationsPeriodValue}
                periods={mInstallation.asyncOperationsPeriods}
                onChange={onAsyncOperationsPeriodChange}
              />
            </div>
          </div>
        </OnlyWith>
      </div>
    </FiltersTemplate>
  );
};

InstallationFilters.propTypes = {
  asyncOperationsPeriodValue: PropTypes.string.isRequired,
  onAsyncOperationsPeriodChange: PropTypes.func.isRequired,
  // From HOC
  disabled: PropTypes.bool.isRequired,
  advanced: PropTypes.bool.isRequired,
  nbFiltersApplied: PropTypes.number.isRequired,
  searchFields: PropTypes.arrayOf(listFeatureSearchFieldShape).isRequired,
  field: PropTypes.string.isRequired,
  filters: PropTypes.shape({
    name: listFilterShape,
    address: listFilterShape,
    device: listFilterShape,
    timeout: listFilterShape,
    country: listFilterShape,
    companyId: listFilterShape,
  }).isRequired,
  isFieldDisplayable: PropTypes.func.isRequired,
  onFieldChange: PropTypes.func.isRequired,
  onFilterFieldChange: PropTypes.func.isRequired,
  onReinit: PropTypes.func.isRequired,
  onSwitch: PropTypes.func.isRequired,
};

module.exports = wrapListFilters(mInstallation.listFeatures().searchFields)(InstallationFilters);



// WEBPACK FOOTER //
// ./routes/app/routes/installations/assets/main/InstallationFilters.js